import React from 'react';

import { Container } from './style';

const News: React.FC = () => {
  return (
      <Container>
          <span>Assuntos do momento no Brasil</span>
          <strong>Coronavírus</strong>
      </Container>
  );
}

export default News;